import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section id="what-is" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 rounded-full text-xs font-medium mb-4">
              About Superbuy Sheet
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-6">
              What Is Superbuy Sheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              <strong className="text-foreground-900">Superbuy Sheet</strong> is an organized collection of product information, 
              links, categories, and research data that helps international shoppers discover products more efficiently. 
              Instead of spending hours scrolling through endless listings, you can use structured Superbuy Sheet resources 
              to find exactly what you need.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Our platform serves as an independent research hub — we curate and organize product data across multiple 
              categories so shoppers can compare options side by side, review quality information, and make confident 
              purchasing decisions without the confusion of navigating unorganized marketplaces.
            </p>
            <Link
              to="/article/what-is-superbuy-sheet"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary-500 text-background-50 rounded-full text-sm font-medium hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Read Full Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/60">
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-5">
              Traditional Searching vs Superbuy Sheet
            </h3>
            <div className="space-y-0">
              <div className="flex items-center gap-3 py-3 border-b border-background-200/50">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-red-100 text-red-500 flex-shrink-0">
                  <i className="ri-close-line text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-600">Hours searching products</span>
                <span className="text-foreground-300 mx-2">→</span>
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 flex-shrink-0">
                  <i className="ri-check-line text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-800 font-medium">Organized collections</span>
              </div>
              <div className="flex items-center gap-3 py-3 border-b border-background-200/50">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-red-100 text-red-500 flex-shrink-0">
                  <i className="ri-close-line text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-600">Random sellers</span>
                <span className="text-foreground-300 mx-2">→</span>
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 flex-shrink-0">
                  <i className="ri-check-line text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-800 font-medium">Structured comparison</span>
              </div>
              <div className="flex items-center gap-3 py-3 border-b border-background-200/50">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-red-100 text-red-500 flex-shrink-0">
                  <i className="ri-close-line text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-600">Limited information</span>
                <span className="text-foreground-300 mx-2">→</span>
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 flex-shrink-0">
                  <i className="ri-check-line text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-800 font-medium">Product research data</span>
              </div>
              <div className="flex items-center gap-3 py-3">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-red-100 text-red-500 flex-shrink-0">
                  <i className="ri-close-line text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-600">Beginner confusion</span>
                <span className="text-foreground-300 mx-2">→</span>
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 flex-shrink-0">
                  <i className="ri-check-line text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-800 font-medium">Step-by-step guidance</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}